import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const LonzaLogo = createIcon({
  displayName: 'AccountCircle',
  viewBox: '0 0 534 200',
  path: [
    <path
      d="M144.235 112.471H168.941V127.059H125.882V79.2941H144.235V112.471Z"
      fill="currentColor"
      key={0}
    />,
    <path
      d="M348.235 80.2353L297.412 80V93.1765C297.412 93.1765 319.529 93.1765 320 93.1765C319.059 94.5882 296 125.412 295.059 126.588L294.824 126.824H346.824V112.941C346.824 112.941 324.471 112.941 324 112.941L325.882 110.353C331.294 103.294 347.529 81.4118 348.235 80.2353Z"
      fill="currentColor"
      key={1}
    />,
    <path
      d="M200.942 78.1177C185.883 78.1177 172.471 87.2941 172.471 103.529C172.471 119.765 185.883 128.706 200.942 128.706C216 128.706 229.412 119.529 229.412 103.529C229.412 87.2941 216 78.1177 200.942 78.1177ZM200.942 115.294C194.353 115.294 189.177 110.118 189.177 103.529C189.177 96.9412 194.353 91.7647 200.942 91.7647C207.53 91.7647 212.706 96.9412 212.706 103.529C212.471 110.118 207.53 115.294 200.942 115.294Z"
      fill="currentColor"
      key={2}
    />,
    <path
      d="M267.059 78.8236C261.882 78.8236 256.235 81.4118 253.177 86.353C253.177 86.1177 253.177 80.2353 253.177 80.2353H236.471V127.294H253.177V104C253.177 95.5295 260.235 93.4118 264 93.6471C269.882 94.1177 272.941 97.6471 272.941 104.941V127.294H289.647V100C289.412 86.8236 279.765 78.5883 267.059 78.8236Z"
      fill="currentColor"
      key={3}
    />,
    <path
      d="M389.647 79.7647C389.647 80 389.647 84.4706 389.647 84.4706L389.412 84.2353C386.118 80.7059 380.471 78.5883 375.294 78.5883C368.471 78.5883 362.118 80.9412 357.647 85.4118C353.176 89.6471 350.823 96 350.823 103.529C350.823 117.882 361.412 128.471 375.529 128.471C379.765 128.471 385.647 127.529 389.412 122.588L389.647 122.353C389.647 122.353 389.647 127.059 389.647 127.294C389.882 127.294 405.882 127.294 406.118 127.294C406.118 127.059 406.118 80.2353 406.118 80C405.882 79.7647 389.882 79.7647 389.647 79.7647ZM379.765 115.294C373.412 115.294 368 110.118 368 103.529C368 97.1765 373.176 91.7647 379.765 91.7647C386.118 91.7647 391.059 96.9412 391.059 103.529C391.059 110.118 386.118 115.294 379.765 115.294Z"
      fill="currentColor"
      key={4}
    />,
  ],
})
